module.exports = __webpack_public_path__ + "img/stock1.859802a7.png";